import React from "react";
import "./privacy.scss";

function PrivacyPolicy() {
  const sections = [
    {
      title: "1. Information We Collect",
      description:
        "We may collect the following categories of information when you visit Compliny.com, engage with our services, or submit data through the Site.",
      subsections: [
        {
          subtitle: "a. Personal Information You Provide",
          detail:
            "This typically happens when you contact us, submit a service request, or sign up for newsletters and notifications.",
          items: [
            "Name",
            "Email address",
            "Phone number",
            "Company name",
            "Any other data you submit through forms, registrations, or emails",
          ],
        },
        {
          subtitle: "b. Automatically Collected Data",
          detail:
            "We gather technical information through cookies, server logs, and analytics tools to understand how the Site is used.",
          items: [
            "IP address",
            "Browser type and version",
            "Operating system",
            "Pages visited and time spent on the Site",
            "Referring URLs",
          ],
        },
      ],
    },
    {
      title: "2. How We Use Your Information",
      description: "We rely on the information we collect to:",
      items: [
        "Respond to your inquiries and support requests",
        "Provide, maintain, and improve our services",
        "Send administrative information such as updates and notifications (only where permitted)",
        "Understand how the Site is used and optimize your experience",
        "Protect our rights and enforce policies",
      ],
    },
    {
      title: "3. Cookies and Tracking Technologies",
      description:
        "We use cookies and similar tracking tools to tailor and improve your experience on the Site.",
      items: [
        "Remember your preferences",
        "Analyze usage patterns",
        "Improve Site performance",
      ],
      detail:
        "Most browsers allow you to control cookies through settings, but disabling them may affect certain Site features.",
    },
    {
      title: "4. Sharing and Disclosure",
      description:
        "We do not sell your personal information. We may share data with trusted partners for the purposes of running the Site safely and efficiently.",
      items: [
        "Service providers who help operate the Site (e.g., hosting, analytics, email services)",
        "Legal authorities, if required by law or to protect our rights",
      ],
      detail: "All third parties are required to respect the confidentiality of your data.",
    },
    {
      title: "5. Data Retention",
      description:
        "We retain personal information only as long as necessary to fulfill the purposes outlined in this policy, including legal and compliance obligations.",
    },
    {
      title: "6. Your Rights",
      description:
        "Depending on your location, you may have rights related to your data, including:",
      items: [
        "Access to your personal information",
        "Correction of inaccurate data",
        "Deletion or restriction of processing",
        "Opting out of marketing communications",
      ],
      detail: "To exercise your rights, reach out using the contact details below.",
    },
    {
      title: "7. Security",
      description:
        "We implement reasonable technical and organizational safeguards to protect your information, though no internet transmission is ever fully secure.",
    },
    {
      title: "8. Changes to This Policy",
      description:
        "We may update this Privacy Policy periodically. The “Last updated” date reflects the latest revision.",
    },
  ];

  return (
    <div className="privacy-page">
      <div className="privacy-card">
        <header className="privacy-hero">
          <p className="privacy-hero-subtitle">Privacy Policy for Compliny.com</p>
          <h1>Privacy Policy</h1>
          <p className="privacy-hero-date">Last updated: January 14, 2026</p>
          <p className="privacy-intro">
            Compliny (“we,” “us,” or “our”) operates the website{" "}
            <a href="https://compliny.com/" target="_blank" rel="noreferrer">
              https://compliny.com/
            </a>{" "}
            (the “Site”). This Privacy Policy explains how we collect, use, disclose,
            and protect your personal data when you use our Site or services.
          </p>
          <p className="privacy-intro">
            By accessing or using the Site, you consent to the collection and use of
            information in accordance with this policy.
          </p>
        </header>
        <main>
          {sections.map((section) => (
            <section className="privacy-section" key={section.title}>
              <h2>{section.title}</h2>
              <p className="privacy-section-description">{section.description}</p>

              {section.subsections?.map((sub) => (
                <div className="privacy-subsection" key={sub.subtitle}>
                  <p className="privacy-subtitle">{sub.subtitle}</p>
                  <p className="privacy-subsection-detail">{sub.detail}</p>
                  <ul>
                    {sub.items.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </div>
              ))}

              {section.items && !section.subsections && (
                <ul>
                  {section.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              )}

              {section.detail && !section.subsections && (
                <p className="privacy-subsection-detail">{section.detail}</p>
              )}
            </section>
          ))}
        </main>
        <footer className="privacy-contact">
          <h2>9. Contact Us</h2>
          <p>
            If you have questions about this policy or wish to exercise your rights,
            please email us at{" "}
            <a href="mailto:info@compliny.com">info@compliny.com</a>.
          </p>
        </footer>
      </div>
    </div>
  );
}

export default PrivacyPolicy;